import { render, staticRenderFns } from "./sns-share.vue?vue&type=template&id=cc299870&scoped=true&"
import script from "./sns-share.vue?vue&type=script&lang=js&"
export * from "./sns-share.vue?vue&type=script&lang=js&"
import style0 from "./sns-share.vue?vue&type=style&index=0&id=cc299870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc299870",
  null
  
)

export default component.exports